import { useEffect, useState, useRef } from "react";
import { orderHistoryData } from "../_request";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import MDAvatar from "components/MDAvatar";
import PropTypes from "prop-types";

import {
  RESTAURANT_LEVEL_HEX_COLOR,
  CASHBACK_STATUS_COLOR,
  CASHBACK_STATUS_COLOR_INFO,
} from "../../../core/constant";
import { ToolTipUI } from "examples/Widgets/ToolTipUI";
import { useTimeline } from "examples/Timeline/context";
import Tooltip from "@mui/material/Tooltip";
import tooltipIcon from "assets/images/icons/catering-icons/tooltip-icon.svg";
import formatNumberWithCommas from "../../../core/utils/formatNumberWithCommas";

export default function data(
  restaurantSearch,
  tierFilter,
  pointEarnedFilter,
  cashbackFilter,
  setTotalPage,
  page,
  setLoader,
  setPage,
  setOrderDataForMobile
) {
  const [orderHistory, setOrderHistory] = useState([]);
  const isInitialRender = useRef(true);
  const isDark = useTimeline();

  const getOrderHistory = async (page) => {
    try {
      setLoader(true);
      const {
        data: { success, data },
      } = await orderHistoryData(
        restaurantSearch,
        tierFilter,
        pointEarnedFilter,
        cashbackFilter,
        page
      );
      if (success) {
        setOrderHistory(data?.updatedOrders);
        setTotalPage(data?.totalPages);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    getOrderHistory(page);
  }, [page, tierFilter, pointEarnedFilter, cashbackFilter]);

  useEffect(() => {
    setPage(1);
  }, [tierFilter, pointEarnedFilter, cashbackFilter, restaurantSearch]);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      getOrderHistory(page);
    }, 750);
    return () => clearTimeout(debounceTimeout);
  }, [restaurantSearch]);

  useEffect(() => {
    const allOrderHistoryData = orderHistory.map((data) => {
      return {
        id: data.id,
        restaurantName: data?._restaurant_store_restaurant_store?.name,
        orderId: data?.orderID,
        deliveredDate: data?.deliveryDate && new Date(data?.deliveryDate).toDateString(),
        orderTier: data?._applied_loyalty_plan_loyalty_plan?.name,
        orderAmount:
          data?.subTotalInCents !== undefined
            ? "$" + formatNumberWithCommas(data.subTotalInCents / 100)
            : "N/A",
        pointEarned: data?.cashbackPoints,
        cashbackStatus: data?.status,
      };
    });
    setOrderDataForMobile(allOrderHistoryData);
  }, [orderHistory]);
  return {
    columns: [
      { Header: "RESTAURANT NAME", accessor: "restaurantName", width: "15%", align: "left" },
      { Header: "ORDER ID", accessor: "orderId", align: "left" },
      { Header: "DELIVERED DATE", accessor: "deliveredDate", align: "center" },
      { Header: "ORDER TIER", accessor: "orderTier", align: "center" },
      { Header: "Subtotal AMOUNT", accessor: "orderAmount", align: "center" },
      { Header: "ESTIMATE POINTS EARNED", accessor: "pointEarned", align: "center" },
      { Header: "CASHBACK STATUS", accessor: "cashbackStatus", align: "center" },
    ],

    rows: orderHistory?.map((data) => {
      return {
        restaurantName: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data?._restaurant_store_restaurant_store?.name
              ? data?._restaurant_store_restaurant_store?.name
              : "-"}
          </MDTypography>
        ),
        orderId: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data?.orderID}
          </MDTypography>
        ),
        deliveredDate: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data?.deliveryDate && new Date(data?.deliveryDate).toDateString()}
          </MDTypography>
        ),
        orderTier: data?._applied_loyalty_plan_loyalty_plan?.name ? (
          <MDBox ml={-1}>
            <MDBox width="84px" textAlign="left">
              <MDBox
                sx={{
                  backgroundColor:
                    RESTAURANT_LEVEL_HEX_COLOR[data?._applied_loyalty_plan_loyalty_plan?.name],
                  borderRadius: "4px",
                  padding: "5px",
                  position: "relative",
                }}
              >
                <MDBox
                  sx={{
                    color: "#FFFFFF",
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "18px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1,
                  }}
                >
                  {data?._applied_loyalty_plan_loyalty_plan?.name}
                </MDBox>
              </MDBox>
            </MDBox>
          </MDBox>
        ) : (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {"-"}
          </MDTypography>
        ),
        orderAmount: (
          <MDBox sx={{ display: "flex", gap: 1 }}>
            <MDTypography variant="caption" color="text" fontWeight="medium">
              {data?.subTotalInCents !== undefined
                ? "$" + formatNumberWithCommas(data.subTotalInCents / 100)
                : "N/A"}
            </MDTypography>
            {!!(data.couponDiscountInCents || data.refundInCents) && (
              <Tooltip
                key={"discountAmount"}
                title={
                  <div style={{ textAlign: "left" }}>
                    {`Subtotal: $${formatNumberWithCommas(data.subTotalInCents / 100)}`}
                    <br />
                    {`Coupon Discount: $${formatNumberWithCommas(
                      data.couponDiscountInCents / 100
                    )}`}
                    <br />
                    {`Refund Amount: $${formatNumberWithCommas(data.refundInCents / 100)}`}
                    <br />
                    <br />
                    <p>
                      {`Original Subtotal: $${formatNumberWithCommas(
                        (data.refundInCents + data.subTotalInCents + data.couponDiscountInCents) /
                          100
                      )}`}
                    </p>
                  </div>
                }
                placeholder="bottom"
              >
                <MDAvatar
                  src={tooltipIcon}
                  name={"discountAmount"}
                  size="sm"
                  sx={{ width: 15, height: 15, cursor: "pointer" }}
                />
              </Tooltip>
            )}
          </MDBox>
        ),
        pointEarned: (
          <MDBox mt={0.5} display="flex" gap={1}>
            {[
              { value: data?.cashbackPoints, tooltip: null },
              {
                value: data?.campaignPoints,
                tooltip: data?.campaignName
                  ? `Extra points earned through the campaign "${data.campaignName}"`
                  : null,
              },
              { value: data?.nsuPoints, tooltip: "Earned Sign up bonus Points" },
              { value: data?.rewardPoints, tooltip: "Earned Reward Points" },
            ]
              .filter((item) => Number(item.value) > 0)
              .map((item, index, arr) => (
                <MDTypography
                  key={index}
                  variant="caption"
                  color={isDark ? "secondary" : "text"}
                  display="flex"
                  sx={{ ml: index === 0 ? 0 : "-2px" }}
                >
                  {index > 0 && "+ "}
                  {item.value}
                  {item.tooltip && (
                    <>
                      {"\u00A0"}
                      <ToolTipUI tooltipText={item.tooltip} />
                    </>
                  )}
                </MDTypography>
              ))}
          </MDBox>
        ),
        cashbackStatus: (
          <Tooltip
            key={"maxCashback"}
            title={CASHBACK_STATUS_COLOR_INFO[data.statusInfo]}
            placeholder="bottom"
            sx={{ cursor: "pointer" }}
          >
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={data?.status}
                color={CASHBACK_STATUS_COLOR[data?.status]}
                variant="gradient"
                size="lg"
              />
            </MDBox>
          </Tooltip>
        ),
      };
    }),
  };
}
data.prototype = {
  restaurantSearch: PropTypes.string,
  tierFilter: PropTypes.string,
  pointEarnedFilter: PropTypes.any,
  cashbackFilter: PropTypes.string,
  page: PropTypes.string,
  setTotalPage: PropTypes.func,
  setLoader: PropTypes.func,
};
